<template>
    <div class="container">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
            <el-breadcrumb-item>Generation</el-breadcrumb-item>
            <el-breadcrumb-item>Result</el-breadcrumb-item>
        </el-breadcrumb>
        <h3>1. Overview</h3>

        <h1 style="text-align: center" v-if="t401">The data is running, please wait patiently.</h1>
        <h1 style="text-align: center" v-if="t402">The ID is incorrect, please re-enter.</h1>
        <h1 style="text-align: center" v-if="t403">The data is in the queue, please wait patiently.</h1>
        <h1 style="text-align: center" v-if="t400">The data operation failed, and the result cannot be obtained. Please check the data and upload it again.</h1>
        <div class="content">
            <el-descriptions :column="2"  border width="190" >
                <el-descriptions-item  v-for="(value,key) in overview">
                    <template slot="label">
                        {{key}}
                    </template>
                    {{value}}
                </el-descriptions-item>
            </el-descriptions>
            <br>
            <el-row :gutter="5" >
                <el-col :span="8">
                    <div id="app1" style="height: 350px" class="content"></div>
                </el-col>
                <el-col :span="8">
                    <div id="app2" style="height: 350px" class="content"></div>
                </el-col>
                <el-col :span="8">
                    <div id="app3" style="height: 350px" class="content"></div>
                </el-col>
            </el-row>
        </div>


        <div style="margin-top: 10px;margin-bottom: 10px">
            <h3 style="display: inline;">2. Results </h3>
            <el-button size="medium" type="primary" plain @click="download()">download as csv</el-button>
        </div>
        <div class="content">
            <el-table
                    :data="entries.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                    stripe
                    style="width: 100%">
                <el-table-column
                        prop="index"
                        label="Index"
                        width="100"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="fig_path"
                        label="2D Structure"
                        align="center">

                    <template slot-scope="scope">
                        <el-image :src="'https://www.csuligroup.com/AIDrugDesigner/getimgdownloadurl'+scope.row.fig_path"></el-image>
                    </template>

                </el-table-column>
                <el-table-column
                        label="information"
                        width="600"
                        align="center">
                    <template slot-scope="scope">
                        <el-descriptions :column="1" :size="size" border width="190">
                            <el-descriptions-item >
                                <template slot="label">
                                    SMILES
                                </template>
                                {{scope.row.SMILES}}
                            </el-descriptions-item>
                            <el-descriptions-item >
                                <template slot="label">
                                    Formula
                                </template>
                                {{scope.row.Formula}}
                            </el-descriptions-item>
                            <el-descriptions-item >
                                <template slot="label">
                                    InChI Key
                                </template>
                                {{scope.row.inchikey}}
                            </el-descriptions-item>
                            <el-descriptions-item >
                                <template slot="label">
                                    MolWt
                                </template>
                                {{scope.row.MolWt}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </template>
                </el-table-column>

                <el-table-column
                        style="margin-left: 200px;"
                        prop="detail"
                        label="Detail"
                        align="center">
                    <template slot="header" slot-scope="scope">
                        detail
                    </template>
                    <template slot-scope="scope" >
                        <el-button
                                size="medium"
                                @click="showDetails(scope.$index, scope.row)">View
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin-top: 5px"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>

        <div style="margin-top: 20px;">
            <h3>3. In Silico ADMET Evaluation</h3>
            <div class="content">
                For additional ADMET evaluation, please visit the external ADMETlab 2.0 server:
                <br><br>
                <a href="https://admetmesh.scbdd.com/service/screening/index" target="_blank" rel="noopener noreferrer">https://admetmesh.scbdd.com/service/screening/index</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Result",
        data() {
            return {
                t401:false,
                t402:false,
                t403:false,
                t400:false,
                pageSize: 20,
                currentPage: 1,
                overview: [
                ],
                result: "",
                sa_image:{},
                qed_image:{},
                molwt_image:{},
                xti:'',
                yti:'',
            }

        },
        created() {
            console.log("created")
            var sid = this.$route.params.uuid
            axios.get("/getinfo",{params:{uuid:sid}}).then(res => {
                this.overview=res.data
                console.log(this.overview)
            })
        },
        mounted() {
            //获取网址中包含的uuid值
            var sid = this.$route.params.uuid

            var ip1="http://localhost:8090/optimization/"
            var ip2="https://www.csuligroup.com/AIDrugDesigner/optimization/"

            var that=this;
            axios.get(ip2+ sid).then(res => {
                console.log(res.data.code)
                if(res.data.code==200)//数据运行成功
                {
                    that.result = res.data.gen_result;
                    that.sa_image =res.data.SA;
                    that.qed_image =res.data.QED;
                    that.molwt_image=res.data.MolWt;

                    var myChart1 = this.$echarts.init(document.getElementById('app1'));
                    var option1 = {
                        color:['#b83b5e'],
                        title: {
                            text: 'SA',
                            left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                            top:'25px',
                        },
                        xAxis: {
                            type: 'category',
                            data: that.sa_image.xti,
                            name: that.sa_image.xlabel,
                            boundaryGap: true,
                        },
                        yAxis: {
                            type: 'value',
                            name: that.sa_image.ylabel
                        },
                        series: [
                            {
                                data: that.sa_image.yti,
                                type: 'bar',
                                // color:red,
                            }
                        ],
                        tooltip: {},
                        grid:{show:true, containLabel: true, bottom: '3%',right:"12%",},
                    };
                    myChart1.setOption(option1);

                    var myChart2 = this.$echarts.init(document.getElementById('app2'));
                    var option2 = {
                        color:['#f08a5d'],
                        title: {
                            text: 'QED',
                            left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                            top:'25px',
                        },
                        xAxis: {
                            type: 'category',
                            data: that.qed_image.xti,
                            name: that.qed_image.xlabel,
                            boundaryGap: true,
                        },
                        yAxis: {
                            type: 'value',
                            name: that.qed_image.ylabel
                        },
                        series: [
                            {
                                data: that.qed_image.yti,
                                type: 'bar',
                                // color:red,
                            }
                        ],
                        tooltip: {},
                        grid:{show:true, containLabel: true, bottom: '3%',right:"12%",},
                    };
                    myChart2.setOption(option2);

                    var myChart3 = this.$echarts.init(document.getElementById('app3'));
                    var option3 = {
                        color:['#f9ed69'],
                        title: {
                            text: 'MolWt',
                            left: 'center',//距离容器左边的距离，可取‘left’，‘right’，‘center’
                            top:'25px',
                        },
                        xAxis: {
                            type: 'category',
                            data: that.molwt_image.xti,
                            name: that.molwt_image.xlabel,
                            boundaryGap: true,
                        },
                        yAxis: {
                            type: 'value',
                            name: that.molwt_image.ylabel
                        },
                        series: [
                            {
                                data: that.molwt_image.yti,
                                type: 'bar',
                                // color:red,
                            }
                        ],
                        tooltip: {},
                        grid:{show:true, containLabel: true, bottom: '3%',right:"23%", },
                    };
                    myChart3.setOption(option3);
                }
                else if(res.data.code==404)//数据运行失败
                {
                    this.$alert("The data operation failed, and the result cannot be obtained. Please check the data and upload it again.")
                }
            }).catch(err => {
                console.log(err);

                axios.get("/search/"+sid).then(res=>{
                    console.log(res.data)
                    if(res.data.code==401)//数据运行中
                    {
                        this.t401=true
                    }
                    else if(res.data.code==402)//uid不存在
                    {
                        this.t402=true
                    }
                    else if(res.data.code==403)//数据排队中
                    {
                        this.t403=true
                    }
                    else if(res.data.code==400)//数据运行失败
                    {
                        this.t400=true
                    }
                })
                // this.$alert("The program is running and the result is not available temporarily. Please wait patiently.")
            })


        },

        computed: {
            entries() {
                return Object.values(this.result);
            },
            total() {
                return this.entries.length;
            }
        },
        methods: {
            //下载csv文件
            download() {
                var sid = this.$route.params.uuid
                var ip1="http://localhost:8090/optimization/"
                var ip2="https://www.csuligroup.com/AIDrugDesigner/optimization/"
                // window.open('http://localhost:8080/000001/000001.csv')
                window.open(ip2 + sid + "/csv")
            },
            showDetails(index, row) {
                console.log(index, row);

                this.$router.push({name: 'GenDetail', params: this.result['molecul_' + index]});
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1160px;
        margin: 0 auto;
    }

    * {
        text-align: left;
    }
    .content{
        box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
        background-color: RGB(255,255,255);
        border-radius: 10px;
        padding: 10px;
    }
</style>
